import { assets } from '../../../data';

const assetsFunc = (state = assets) => state;

export default assetsFunc;